export function isTimeoutError(error: {code?: string}) {
    return ('code' in error && error.code === 'ECONNABORTED');
}
